import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const calCom = defineConnector({
  identifier: "calCom",
  name: "Cal.com",
  tagLine: "Scheduling platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.cal\\.com/v2/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Cal.com](https://cal.com/) and navigate to **Settings** > **Developer** > **API Keys** to create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Cal.com API key",
          required: true,
          placeholder: "cal_live_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cal.com/v2/me",
  },
});
